import React from 'react';
import { useTranslation } from 'react-i18next';
import { EnumTypePQRS } from '../../../constants/PqrsType';
import Pqrsd from '..';

const PqrsdAnonyme = () => {
  const { t } = useTranslation();
  return (
    <Pqrsd
      title={t('pages.pqrs.anonyme.title')}
      subTitle={t('pages.pqrs.anonyme.subTitle')}
      typePqrs={EnumTypePQRS.Anonymous}
    />
  );
};
export default PqrsdAnonyme;
